// // Paleta de colores pasteles
// export const pastelColors = [
//     { name: "Blanco humo", hex: "#F5F5F5" },
//     { name: "Marfil suave", hex: "#FFF8E7" },
//     { name: "Crema claro", hex: "#FFF3CD" },

//     // Rosas
//     { name: "Rosa pastel", hex: "#FFC1CC" },
//     { name: "Rosa algodón de azúcar", hex: "#FFD6E7" },
//     { name: "Rosa suave", hex: "#FFB6C1" },
//     { name: "Rosa bebé", hex: "#FADADD" },
//     { name: "Rosa viejo pastel", hex: "#E7B8C8" },

//     // Rojos / Corales suaves
//     { name: "Coral pastel", hex: "#FFB3AB" },
//     { name: "Coral suave", hex: "#FFCCC2" },
//     { name: "Salmón pastel", hex: "#FFC9A9" },
//     { name: "Melón suave", hex: "#FFD1B3" },

//     // Naranjas
//     { name: "Durazno pastel", hex: "#FFDAB9" },
//     { name: "Durazno suave", hex: "#FFE2C6" },
//     { name: "Naranja crema", hex: "#FFE0B2" },
//     { name: "Albaricoque pastel", hex: "#FFD1A3" },

//     // Amarillos
//     { name: "Amarillo pastel", hex: "#FFF9C4" },
//     { name: "Amarillo mantequilla", hex: "#FFF2B2" },
//     { name: "Vainilla suave", hex: "#FFF3C6" },
//     { name: "Lima pastel", hex: "#F3F9A7" },

//     // Verdes
//     { name: "Verde menta pastel", hex: "#C8F7DC" },
//     { name: "Verde menta suave", hex: "#D5F5E3" },
//     { name: "Verde agua pastel", hex: "#B2F2E6" },
//     { name: "Verde té matcha suave", hex: "#D8EFC4" },
//     { name: "Verde pistacho pastel", hex: "#E5F6C7" },
//     { name: "Verde musgo claro", hex: "#DCEECF" },

//     // Verdes azulados / Turquesas
//     { name: "Aqua pastel", hex: "#CFF5F5" },
//     { name: "Turquesa pastel", hex: "#B5EAEA" },
//     { name: "Turquesa suave", hex: "#CDEFF2" },
//     { name: "Verde agua marina", hex: "#BDE7E1" },

//     // Azules
//     { name: "Azul bebé", hex: "#BDE0FE" },
//     { name: "Azul cielo pastel", hex: "#CDE9FF" },
//     { name: "Azul hielo", hex: "#E0F2FF" },
//     { name: "Azul niebla suave", hex: "#D6E4F0" },
//     { name: "Azul grisáceo pastel", hex: "#C7D2E3" },

//     // Violetas / Morados
//     { name: "Lavanda pastel", hex: "#E6E6FA" },
//     { name: "Lila pastel", hex: "#E3D0FF" },
//     { name: "Malva suave", hex: "#E0C3FC" },
//     { name: "Lavanda grisácea", hex: "#D8D0E5" },
//     { name: "Morado suave", hex: "#D7C2FF" },

//     // Neutros cálidos
//     { name: "Arena pastel", hex: "#F3E2D2" },
//     { name: "Beige suave", hex: "#F5E6D3" },
//     { name: "Champagne pastel", hex: "#F7E7CE" },
//     { name: "Tierra clara", hex: "#E9D7C3" },

//     // Neutros fríos / Grises suaves
//     { name: "Gris perla", hex: "#E5E5EA" },
//     { name: "Gris humo pastel", hex: "#DCDDE1" },
//     { name: "Gris azulado suave", hex: "#CED6E0" },
//     { name: "Gris cálido pastel", hex: "#E8E0D9" },
// ];


export const pastelColors = [
    { name: "Arena clara", hex: "#F2E7C9" },
    { name: "Beige cálido", hex: "#F4D8A8" },

    // Naranjas / Corales claros
    { name: "Coral claro", hex: "#F9B59D" },
    { name: "Durazno claro", hex: "#FFCB9A" },
    { name: "Salmón suave", hex: "#F8BFAE" },

    // Amarillos altos (sin llegar a quemar la vista)
    { name: "Amarillo claro", hex: "#F8E98C" },
    { name: "Oro suave", hex: "#F5D96A" },

    // Verdes claros
    { name: "Verde lima claro", hex: "#D7F27D" },
    { name: "Verde menta", hex: "#BFF2A1" },
    { name: "Verde hierba claro", hex: "#C8E89E" },

    // Turquesas / Aqua
    { name: "Aqua claro", hex: "#AEEFEB" },
    { name: "Turquesa suave", hex: "#9BE0D6" },

    // Azules (claros pero no pasteles)
    { name: "Azul cielo vivo", hex: "#A7D2FF" },
    { name: "Azul acero claro", hex: "#AFC8E2" },
    { name: "Azul nube", hex: "#C0DBFF" },

    // Violetas
    { name: "Lavanda clara", hex: "#D4C8FF" },
    { name: "Violeta suave", hex: "#CDB8FF" },

    // Neutros
    { name: "Gris cálido claro", hex: "#E1D9CE" },
    { name: "Gris frío claro", hex: "#D8DDE5" },
    { name: "Humo claro", hex: "#E5E5E5" }
];
